<script>
export default {
  props: {
    person: {
      type: Object,
      required: true
    },
    performs: { type: Array, required: true }
  },
  computed: {
    displayListOfPerforms() {
      const list = this.performs.slice(0, 9)
      return list
    },
    hiddenListOfPerforms() {
      const list = this.performs.slice(9, this.performs.length)
      return list
    }
  },

  methods: {
    getRole(perform) {
      for (let i = 0; i < perform.troupe.length; i++) {
        for (let j = 0; j < perform.troupe[i].value.length; j++) {
          if (perform.troupe[i].value[j]._id === this.person._id) {
            return perform.troupe[i].title
          }
        }
      }
      for (let i = 0; i < perform.staging.length; i++) {
        for (let j = 0; j < perform.staging[i].value.length; j++) {
          if (perform.staging[i].value[j]._id === this.person._id) {
            return perform.staging[i].title
          }
        }
      }
      return ''
    },
    getMoreDetails() {
      const item = this.$refs.list
      const icon = document.getElementById('iconDown')
      if (item.className === 'duration-500 h-0 overflow-hidden') {
        console.log(item)
        item.style.height = `${item.scrollHeight}px`
        item.className = 'duration-500 overflow-hidden'
        icon.style.transform = 'rotate(0.25turn)'
      } else {
        item.className = 'duration-500 h-0 overflow-hidden'
        item.style.height = '0px'
        icon.style.transform = 'rotate(0.75turn)'
      }
    }
  }
}
</script>
<template>
  <div class="flex-1 h-full flex flex-col space-y-2 items-stretch">
    <div class="flex flex-col space-y-2 mb-auto">
      <div class="flex flex-col space-y-2">
        <div v-for="perform in displayListOfPerforms" :key="perform._id">
          <router-link :to="`/theater/performs/${perform._id}`">
            <p
              class="font-sans text-lg text-dark-gray"
              v-if="
                getRole(perform) !== 'В спектакле участвуют:' ||
                getRole(perform) !== 'В спектакле принимают участие:'
              "
            >
              <b class="font-semibold"> «{{ perform.name }}» </b> -
              {{ getRole(perform) }}
            </p>
            <p class="detail_text" style="text-decoration: underline" v-else>
              {{ perform.name }}
            </p>
          </router-link>
        </div>
      </div>
      <div ref="list" class="duration-500 h-0 overflow-hidden">
        <div class="flex flex-col space-y-2">
          <div v-for="perform in hiddenListOfPerforms" :key="perform._id">
            <router-link :to="`/theater/performs/${perform._id}`">
              <p
                class="font-sans text-lg text-dark-gray"
                v-if="
                  getRole(perform) !== 'В спектакле участвуют:' ||
                  getRole(perform) !== 'В спектакле принимают участие:'
                "
              >
                <b class="font-semibold"> «{{ perform.name }}» </b> -
                {{ getRole(perform) }}
              </p>
              <p class="detail_text" style="text-decoration: underline" v-else>
                {{ perform.name }}
              </p>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div
      class="justify-self-end mt-auto"
      v-if="performs.length > 8"
    >
      <button
        class="flex flex-row justify-items-center focus:outline-none"
        @click="getMoreDetails()"
      >
        <span class="font-sans text-lg2 text-gray-900"> Подробнее </span>
        <span class="m-0" id="btn">
          <RIcon id:="icon" class="h-4 w-2 ml-2 mt-2" id="iconDown" :style="{
          transform: 'rotate(0.75turn)' }" icon="angle-left" />
        </span>
      </button>
    </div>
  </div>
</template>
